import XAPPService from 'app/Core/services/XAPPService';
export const GERENCIADOR_PROCESSO_WARNING = '[GERENCIADOR PROCESSO APP] GERENCIADOR PROCESSO WARNING';
export const GERENCIADOR_PROCESSO_INFO = '[GERENCIADOR PROCESSO APP] GERENCIADOR PROCESSO INFO';
export const GERENCIADOR_PROCESSO_ERROR = '[GERENCIADOR PROCESSO APP] GERENCIADOR PROCESSO ERROR';

export function acao(_ATarefa, _AParams, _AAcao, _AClose, _AGetNext) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var obj = JSON.parse(JSON.stringify(_ATarefa));

        obj.fluxo = null;
        obj.requeridos = null;
        obj.acao = _AAcao.idfluxopassoacao;
        obj.historico = _AAcao.historico;

        AActions = XAPPService.XappFlowActionFactory(_AParams.empresa, AActions, "tarefa", "EXECUTARACAO", obj, "", AConditionsAND, AConditionsOR);
        XAPPService.XappFlowAction(AActions, _AParams)
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: GERENCIADOR_PROCESSO_WARNING,
                            payload: response.warning
                        })
                    ])
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: GERENCIADOR_PROCESSO_INFO,
                            payload: response.info
                        }),
                    ]).then(() => {
                        if (![null, 666, 999].includes(_AAcao.proximopasso)) {
                            if (_AGetNext) {
                                _AGetNext(response.data);
                            }
                        } else {
                            if (_AClose) {
                                _AClose(response.data);
                            }
                        }
                    });
                }
            }
            ).catch(error => {
                return dispatch({
                    type: GERENCIADOR_PROCESSO_ERROR,
                    payload: error
                });
            });
    };
}
